[
    [
        "Inter-Hemispheric",
        "Left Cerebrum",
        "Right Cerebrum",
        "Right Cerebellum",
        "Right Brainstem",
        "Left Brainstem",
        "Left Cerebellum",
        "Unidentified Level 1"
    ],
    [
        "Posterior Lobe (L)",
        "Posterior Lobe (C)",
        "Posterior Lobe (R)",
        "Anterior Lobe (L)",
        "Anterior Lobe (C)",
        "Anterior Lobe (R)",
        "Frontal-Temporal Space (L)",
        "Frontal-Temporal Space (R)",
        "Limbic Lobe (L)",
        "Limbic Lobe (C)",
        "Limbic Lobe (R)",
        "Medulla (L)",
        "Medulla (C)",
        "Medulla (R)",
        "Pons (L)",
        "Pons (C)",
        "Pons (R)",
        "Midbrain (L)",
        "Midbrain (C)",
        "Midbrain (R)",
        "Sub-lobar (L)",
        "Sub-lobar (C)",
        "Sub-lobar (R)",
        "Occipital Lobe (L)",
        "Occipital Lobe (C)",
        "Occipital Lobe (R)",
        "Temporal Lobe (L)",
        "Temporal Lobe (R)",
        "Parietal Lobe (L)",
        "Parietal Lobe (C)",
        "Parietal Lobe (R)",
        "Frontal Lobe (L)",
        "Frontal Lobe (C)",
        "Frontal Lobe (R)",
        "Unidentified Level 2"
    ],
    [
        "Posterior Cingulate (L)",
        "Posterior Cingulate (C)",
        "Posterior Cingulate (R)",
        "Anterior Cingulate (L)",
        "Anterior Cingulate (C)",
        "Anterior Cingulate (R)",
        "Subcallosal Gyrus (L)",
        "Subcallosal Gyrus (R)",
        "Sub-Gyral (L)",
        "Sub-Gyral (R)",
        "Transverse Temporal Gyrus (L)",
        "Transverse Temporal Gyrus (R)",
        "Uncus (L)",
        "Uncus (R)",
        "Rectal Gyrus (L)",
        "Rectal Gyrus (R)",
        "Fusiform Gyrus (L)",
        "Fusiform Gyrus (R)",
        "Inferior Occipital Gyrus (L)",
        "Inferior Occipital Gyrus (R)",
        "Inferior Temporal Gyrus (L)",
        "Inferior Temporal Gyrus (R)",
        "Insula (L)",
        "Insula (R)",
        "Parahippocampal Gyrus (L)",
        "Parahippocampal Gyrus (R)",
        "Lingual Gyrus (L)",
        "Lingual Gyrus (C)",
        "Lingual Gyrus (R)",
        "Middle Occipital Gyrus (L)",
        "Middle Occipital Gyrus (R)",
        "Orbital Gyrus (L)",
        "Orbital Gyrus (R)",
        "Middle Temporal Gyrus (L)",
        "Middle Temporal Gyrus (R)",
        "Superior Temporal Gyrus (L)",
        "Superior Temporal Gyrus (R)",
        "Superior Occipital Gyrus (L)",
        "Superior Occipital Gyrus (R)",
        "Precentral Gyrus (L)",
        "Precentral Gyrus (R)",
        "Inferior Frontal Gyrus (L)",
        "Inferior Frontal Gyrus (R)",
        "Cuneus (L)",
        "Cuneus (C)",
        "Cuneus (R)",
        "Angular Gyrus (L)",
        "Angular Gyrus (R)",
        "Supramarginal Gyrus (L)",
        "Supramarginal Gyrus (R)",
        "Cingulate Gyrus (L)",
        "Cingulate Gyrus (C)",
        "Cingulate Gyrus (R)",
        "Inferior Parietal Lobule (L)",
        "Inferior Parietal Lobule (R)",
        "Precuneus (L)",
        "Precuneus (C)",
        "Precuneus (R)",
        "Superior Parietal Lobule (L)",
        "Superior Parietal Lobule (R)",
        "Middle Frontal Gyrus (L)",
        "Middle Frontal Gyrus (R)",
        "Paracentral Lobule (L)",
        "Paracentral Lobule (C)",
        "Paracentral Lobule (R)",
        "Postcentral Gyrus (L)",
        "Postcentral Gyrus (C)",
        "Postcentral Gyrus (R)",
        "Precentral Gyrus (L)",
        "Precentral Gyrus (C)",
        "Precentral Gyrus (R)",
        "Superior Frontal Gyrus (L)",
        "Superior Frontal Gyrus (C)",
        "Superior Frontal Gyrus (R)",
        "Medial Frontal Gyrus (L)",
        "Medial Frontal Gyrus (C)",
        "Medial Frontal Gyrus (R)",
        "Uvula of Vermis (L)",
        "Uvula of Vermis (C)",
        "Uvula of Vermis (R)",
        "Pyramis of Vermis (L)",
        "Pyramis of Vermis (C)",
        "Pyramis of Vermis (R)",
        "Tuber of Vermis (L)",
        "Tuber of Vermis (C)",
        "Tuber of Vermis (R)",
        "Declive of Vermis (L)",
        "Declive of Vermis (C)",
        "Declive of Vermis (R)",
        "Culmen of Vermis (L)",
        "Culmen of Vermis (C)",
        "Culmen of Vermis (R)",
        "Cerebellar Tonsil (L)",
        "Cerebellar Tonsil (C)",
        "Cerebellar Tonsil (R)",
        "Inferior Semi-Lunar Lobule (L)",
        "Inferior Semi-Lunar Lobule (C)",
        "Inferior Semi-Lunar Lobule (R)",
        "Fastigium (L)",
        "Fastigium (R)",
        "Nodule (L)",
        "Nodule (C)",
        "Nodule (R)",
        "Uvula (L)",
        "Uvula (C)",
        "Uvula (R)",
        "Pyramis (L)",
        "Pyramis (C)",
        "Pyramis (R)",
        "Tuber (L)",
        "Tuber (R)",
        "Declive (L)",
        "Declive (C)",
        "Declive (R)",
        "Culmen (L)",
        "Culmen (C)",
        "Culmen (R)",
        "Cerebellar Lingual (L)",
        "Cerebellar Lingual (C)",
        "Cerebellar Lingual (R)",
        "Extra-Nuclear (L)",
        "Extra-Nuclear (C)",
        "Extra-Nuclear (R)",
        "Lentiform Nucleus (L)",
        "Lentiform Nucleus (R)",
        "Claustrum (L)",
        "Claustrum (R)",
        "Thalamus (L)",
        "Thalamus (R)",
        "Caudate (L)",
        "Caudate (R)",
        "Lateral Ventricle (L)",
        "Lateral Ventricle (R)",
        "Fourth Ventricle",
        "Third Ventricle",
        "Unidentified Level 3"
    ],
    [
        "Cerebro-Spinal Fluid (L)",
        "Cerebro-Spinal Fluid (C)",
        "Cerebro-Spinal Fluid (R)",
        "Gray Matter (L)",
        "Gray Matter (C)",
        "Gray Matter (R)",
        "White Matter (L)",
        "White Matter (C)",
        "White Matter (R)",
        "Unidentified Level 4"
    ],
    [
        "Hippocampus (L)",
        "Hippocampus (R)",
        "Amygdala (L)",
        "Amygdala (R)",
        "Red Nucleus (L)",
        "Red Nucleus (R)",
        "Substania Nigra (L)",
        "Substania Nigra (R)",
        "Brodmann area 1 (L)",
        "Brodmann area 1 (R)",
        "Brodmann area 2 (L)",
        "Brodmann area 2 (R)",
        "Brodmann area 3 (L)",
        "Brodmann area 3 (R)",
        "Brodmann area 4 (L)",
        "Brodmann area 4 (R)",
        "Brodmann area 5 (L)",
        "Brodmann area 5 (R)",
        "Brodmann area 6 (L)",
        "Brodmann area 6 (R)",
        "Brodmann area 7 (L)",
        "Brodmann area 7 (R)",
        "Brodmann area 8 (L)",
        "Brodmann area 8 (R)",
        "Brodmann area 9 (L)",
        "Brodmann area 9 (R)",
        "Brodmann area 10 (L)",
        "Brodmann area 10 (R)",
        "Brodmann area 11 (L)",
        "Brodmann area 11 (R)",
        "Brodmann area 12 (L)",
        "Brodmann area 12 (R)",
        "Brodmann area 13 (L)",
        "Brodmann area 13 (R)",
        "Brodmann area 17 (L)",
        "Brodmann area 17 (R)",
        "Brodmann area 18 (L)",
        "Brodmann area 18 (C)",
        "Brodmann area 18 (R)",
        "Brodmann area 19 (L)",
        "Brodmann area 19 (R)",
        "Brodmann area 20 (L)",
        "Brodmann area 20 (R)",
        "Brodmann area 21 (L)",
        "Brodmann area 21 (R)",
        "Brodmann area 22 (L)",
        "Brodmann area 22 (R)",
        "Brodmann area 23 (L)",
        "Brodmann area 23 (R)",
        "Brodmann area 24 (L)",
        "Brodmann area 24 (R)",
        "Brodmann area 25 (L)",
        "Brodmann area 25 (R)",
        "Brodmann area 27 (L)",
        "Brodmann area 27 (R)",
        "Brodmann area 28 (L)",
        "Brodmann area 28 (R)",
        "Brodmann area 29 (L)",
        "Brodmann area 29 (R)",
        "Brodmann area 30 (L)",
        "Brodmann area 30 (R)",
        "Brodmann area 31 (L)",
        "Brodmann area 31 (R)",
        "Brodmann area 32 (L)",
        "Brodmann area 32 (R)",
        "Brodmann area 33 (L)",
        "Brodmann area 33 (R)",
        "Brodmann area 34 (L)",
        "Brodmann area 34 (R)",
        "Brodmann area 35 (L)",
        "Brodmann area 35 (R)",
        "Brodmann area 36 (L)",
        "Brodmann area 36 (R)",
        "Brodmann area 37 (L)",
        "Brodmann area 37 (R)",
        "Brodmann area 38 (L)",
        "Brodmann area 38 (R)",
        "Brodmann area 39 (L)",
        "Brodmann area 39 (R)",
        "Brodmann area 40 (L)",
        "Brodmann area 40 (R)",
        "Brodmann area 41 (L)",
        "Brodmann area 41 (R)",
        "Brodmann area 42 (L)",
        "Brodmann area 42 (R)",
        "Brodmann area 43 (L)",
        "Brodmann area 43 (R)",
        "Brodmann area 44 (L)",
        "Brodmann area 44 (R)",
        "Brodmann area 45 (L)",
        "Brodmann area 45 (R)",
        "Brodmann area 46 (L)",
        "Brodmann area 46 (R)",
        "Brodmann area 47 (L)",
        "Brodmann area 47 (R)",
        "Caudate Tail (L)",
        "Caudate Tail (R)",
        "Caudate Body (L)",
        "Caudate Body (R)",
        "Caudate Head (L)",
        "Caudate Head (R)",
        "Dentate (L)",
        "Dentate (R)",
        "Ventral Anterior Nucleus (L)",
        "Ventral Anterior Nucleus (R)",
        "Ventral Posterior Medial Nucleus (L)",
        "Ventral Posterior Medial Nucleus (R)",
        "Ventral Posterior Lateral Nucleus (L)",
        "Ventral Posterior Lateral Nucleus (R)",
        "Medial Dorsal Nucleus (L)",
        "Medial Dorsal Nucleus (R)",
        "Lateral Dorsal Nucleus (L)",
        "Lateral Dorsal Nucleus (R)",
        "Pulvinar (L)",
        "Pulvinar (R)",
        "Lateral Posterior Nucleus (L)",
        "Lateral Posterior Nucleus (R)",
        "Ventral Lateral Nucleus (L)",
        "Ventral Lateral Nucleus (R)",
        "Midline Nucleus (L)",
        "Midline Nucleus (R)",
        "Anterior Nucleus (L)",
        "Anterior Nucleus (R)",
        "Mammillary Body (L)",
        "Mammillary Body (R)",
        "Optic Tract (L)",
        "Optic Tract (C)",
        "Optic Tract (R)",
        "Anterior Commissure (L)",
        "Anterior Commissure (C)",
        "Anterior Commissure (R)",
        "Corpus Callosum (L)",
        "Corpus Callosum (C)",
        "Corpus Callosum (R)",
        "Medial Globus Pallidus (L)",
        "Medial Globus Pallidus (R)",
        "Lateral Globus Pallidus (L)",
        "Lateral Globus Pallidus (R)",
        "Nucleus Accumbens Septi (L)",
        "Nucleus Accumbens Septi (R)",
        "Medial Geniculum Body (L)",
        "Medial Geniculum Body (R)",
        "Lateral Geniculum Body (L)",
        "Lateral Geniculum Body (R)",
        "Subthalamic Nucleus (L)",
        "Subthalamic Nucleus (R)",
        "Putamen (L)",
        "Putamen (R)",
        "Hypothalamus",
        "Unidentified Level 5"
    ]
]
